export const testimonialLogic = ($) => {
  const testimonialsCarouselElement = $(
    ".review-carousel-container .review-carousel"
  );

  // save margin-left of carousel to variable
  const carouselLeftMargin =
    window.innerWidth >= 1200 ? 97 : window.innerWidth >= 768 ? 70 : 0;

  const testimonialWidth = $(
    ".review-carousel-container .review-carousel .review"
  ).width();

  if (testimonialsCarouselElement.length <= 0) {
    return;
  }

  let isDown = false;
  let isDragging = false;
  let startX;
  let currentPos;

  // Returns the max transform left distance for carousel
  const maxLeft = ($this) => {
    if ($this.width() < window.innerWidth) {
      return $this.width() / 2 - testimonialWidth / 2 - carouselLeftMargin / 2;
    } else {
      return window.innerWidth / 2 - testimonialWidth / 2 - carouselLeftMargin;
    }
  };

  // Returns the max transform right distance for carousel
  const maxRight = ($this) => {
    if ($this.width() < window.innerWidth) {
      return (
        -Math.abs($this.width()) / 2 +
        testimonialWidth / 2 -
        carouselLeftMargin / 2
      );
    } else {
      return (
        -Math.abs($this.width()) +
        window.innerWidth / 2 +
        testimonialWidth / 2 -
        carouselLeftMargin
      );
    }
  };

  const downFunction = (event, $this) => {
    isDown = true;
    // add active class from carousel to remove hand cursor
    $this[0].classList.add("active");
    // Locate start position where user first clicks
    // if click event is undefined it must be from a mobile, so we change the event handle
    // function to work with mobile
    startX = event.pageX ? event.pageX : event.touches[0].clientX;
    // get current transform positions
    const currTrans = $this.css("transform").split(/[()]/)[1];
    // seperate out transformX position from returned transform string
    currentPos = currTrans !== undefined ? currTrans.split(",")[4] : 0;
  };

  const leaveFunction = ($this) => {
    isDown = false;
    // remove active class from carousel to remove hand cursor
    $this[0].classList.remove("active");
  };

  const upFunction = ($this) => {
    isDown = false;
    // remove active class from carousel to remove hand cursor
    $this[0].classList.remove("active");
    isDragging = false;
  };
  const moveFunction = (event, $this, carouselLeft) => {
    if (!isDown) return;
    isDragging = true;
    const pos = event.pageX ? event.pageX : event.touches[0].clientX;
    // minus position of mouse moving from position declared when mouse was first down
    const x = startX - pos;
    // subtract that x position from current carousel position
    const newPos = currentPos - x;

    if (newPos > maxLeft($this)) {
      $this.css("transform", `translateX(${maxLeft($this)}px)`);
    } else if (newPos <= maxRight($this, carouselLeft)) {
      $this.css("transform", `translateX(${maxRight($this, carouselLeft)}px`);
    } else {
      $this.css("transform", `translateX(${newPos}px`);
    }
  };

  testimonialsCarouselElement.each(function () {
    const carouselLeft = $(this).offset().left;
    $(this).on("mousedown touchstart", (event) => {
      downFunction(event, $(this));
    });
    $(this).on("mouseup touchend", (event) => {
      upFunction($(this));
    });
    $(this).on("mouseleave touchcancel", (event) => {
      leaveFunction($(this));
    });
    $(this).on("mousemove touchmove", (event) => {
      moveFunction(event, $(this), carouselLeft);
    });
  });

  const testimonials = $(".review-carousel-container .review-carousel .review");
  testimonials.each(function () {
    $(this).on("mouseup", function () {
      const testimonialCarousel = $(this).parent();
      // this gets the margin for the testimonial card, which we need
      // to line up the card to the side of the screen on mobile devices
      const margin = parseInt($(this).children().first().css("marginLeft"), 10);

      if (!isDragging) {
        const testimonialPosition = $(this).offset().left;
        // we get half of the testimonial card width so that we can
        // add it later to the position to center the card
        const testimonialWidth = $(this).width() / 2;
        const windowMiddle = window.innerWidth / 2;

        // this calculation when substracted from the card's current position
        // centers the card on desktop view
        const centerPosition =
          window.innerWidth >= 768
            ? testimonialPosition - windowMiddle + testimonialWidth
            : testimonialPosition -
              windowMiddle +
              testimonialWidth +
              margin * 2;

        // Add class when mouse is up to animate that movement of the carousel
        testimonialCarousel.addClass("animate");
        testimonialCarousel.css(
          "transform",
          `translateX(${currentPos - centerPosition}px`
        );
        // then remove the animation as otherwise when we try to drag the carousel
        // it will lag
        setTimeout(() => {
          testimonialCarousel.removeClass("animate");
        }, 500);
      }
    });
  });

  // *****************
  // Check if review needs scroll bar
  // *****************
  $(".review-carousel .review .review-wrapper .quote").each(function () {
    const scrollHeight = $(this)[0].scrollHeight;
    const clientHeight = $(this)[0].clientHeight;
    const maxScrollDistance = scrollHeight - clientHeight;
    const quote = $(this);
    const topArrow = $(this)
      .parent()
      .parent()
      .children(".reviewer")
      .children(".arrow-container")
      .children(".top-arrow");
    const bottomArrow = $(this)
      .parent()
      .parent()
      .children(".reviewer")
      .children(".arrow-container")
      .children(".bottom-arrow");

    if (scrollHeight > clientHeight) {
      $(this).parent().addClass("scrollable");
      topArrow.removeClass("hide");
      bottomArrow.removeClass("hide");
    }

    $(this).scroll(function () {
      if ($(this).scrollTop() > 20) {
        $(this).parent().addClass("scrolled");
      } else {
        $(this).parent().removeClass("scrolled");
      }
    });

    const scrollDown = () => {
      const scrollDistance = quote.scrollTop();
      quote.animate(
        {
          scrollTop: scrollDistance + 100,
        },
        500,
        "linear"
      );
    };

    const scrollUp = () => {
      const scrollDistance = quote.scrollTop();
      quote.animate(
        {
          scrollTop: scrollDistance - 100,
        },
        500,
        "linear"
      );
    };

    let intervalScrollUp;
    let intervalScrollDown;

    topArrow.on("click", function () {
      scrollUp();
    });

    bottomArrow.on("click", function () {
      scrollDown();
    });

    topArrow.on("mousedown touchstart", function () {
      intervalScrollUp = setInterval(scrollUp, 500);
    });
    topArrow.on("mouseup touchend", function () {
      clearInterval(intervalScrollUp);
    });

    bottomArrow.on("mousedown touchstart", function () {
      intervalScrollDown = setInterval(scrollDown, 500);
    });
    bottomArrow.on("mouseup touchend touchcancel", function () {
      clearInterval(intervalScrollDown);
    });
  });
};
